import { DealValue, DealQuestion } from ".";

export class DealItemDataConfig {

  /**
  * Gets or sets the unique identifier for the deal item that the data is associated with.
  */
  dealItemId: string | null = null;

  /**
  * Gets or sets if the data was taken from live or the users' data.
  */
  isLive: boolean | null = false;

  /**
  * Gets or sets the collection of deal values indexed by their model value identifier.
  */
  dataMapByModelValueId: Map<string, DealValue[]> | null = new Map<string, DealValue[]>();

  /**
  * Gets or sets the collection of deal values indexed by their model varName, code
  */
  dataMapByVarNameCode: Map<string, DealValue[]> | null = new Map<string, DealValue[]>();

  /**
  * Gets or sets the configuration records in a hierarchical format for the deal item.
  */
  configDisplayHierarchical: DealQuestion[] = [];

  /**
  * Get or sets the full collection of configuration records indexed by their model value id.
  */
  configMapByModelValueId: Map<string, DealQuestion> | null = new Map<string, DealQuestion>();
}
